import React from "react";
import {
  List,
  DatagridConfigurable,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  ExportButton,
  CreateButton,
  useDefaultTitle,
  Identifier,
} from "react-admin";
import { Box, Typography } from "@mui/material";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <ExportButton />
    <CreateButton label="Add Admin" to="/admins/create" />
  </TopToolbar>
);

const AdminsTitle = () => {
  const title = useDefaultTitle();
  return (
    <>
      <title>{`${title} - Admins`}</title>
      <span>Admins</span>
    </>
  );
};

const AdminsList = () => (
  <>
    <Box px={2} pt={2}>
      <Typography variant="body2" color="textSecondary">
        This is the single source of truth for admin access. Everyone listed here
        can sign in to this panel, manage content, and access protected data.
        Changes take effect immediately for the panel and database rules, and
        within a minute for the sync API.
      </Typography>
    </Box>
    <List
      resource="admins"
      perPage={50}
      actions={<ListActions />}
      filters={[]}
      title={<AdminsTitle />}
      sort={{ field: "email", order: "ASC" }}
    >
      <DatagridConfigurable
        rowClick={(id: Identifier) => `/admins/${id}/edit`}
        bulkActionButtons={false}
      >
        <TextField source="email" label="Email" />
        <TextField source="displayName" label="Name" />
        <TextField source="note" label="Note" />
      </DatagridConfigurable>
    </List>
  </>
);

export default AdminsList;
